const GENERIC_CONVERSATION_TITLES = new Set([
  'новый диалог',
  'новый чат',
  'new dialog',
  'new chat',
  'new conversation',
  'conversation',
])

function normalizeConversationTitle(value?: string | null): string {
  return String(value || '').trim().toLowerCase()
}

export function isGenericConversationTitle(value?: string | null): boolean {
  const normalized = normalizeConversationTitle(value)
  if (!normalized) return true
  return GENERIC_CONVERSATION_TITLES.has(normalized)
}

export function resolveConversationTitle(
  title?: string | null,
  lastMessage?: string | null,
  fallback = 'Новый диалог',
): string {
  const safeTitle = String(title || '').trim()
  const safeLastMessage = String(lastMessage || '').trim()
  if (safeTitle && !isGenericConversationTitle(safeTitle)) return safeTitle
  if (safeLastMessage) return safeLastMessage
  if (safeTitle) return safeTitle
  return fallback
}
